import assign from 'lodash.assign';
import {UPDATE_AMOUNT_TILLAGG, GET_LOCAL_TILLAGG, UPDATE_CHECKED, GET_LOCAL_TILLAGGFORM, UPDATE_CHECKED_BANDEROLL, UPDATE_ARTICLE} from './action';


const initialState = {
    tillagg: [
        {
            product_name: 'Askkopp',
            description: 'Askkopp i pulverlackerad aluminium. Galler i rostfritt stål. Akskoppen har en inre behållare som förenklar tömningen. För montage på vägg eller stolpe.',
            amount: "",
            image: "cigg_hallare.svg",
            price: "675:-/st"
        },
        {
            product_name: 'Griffeltavla',
            description: 'För anslag av dagensrätt etc. Hängs direkt på staketet.',
            amount: "",
            image: "tavla.svg",
            price: "990:-/st"
        },
        {
            product_name: 'Menytavla',
            description: 'I natureloxerad aluminium med frontglas av polycarbonat. Finns för A4 och A3-format. Kan monteras direkt på vägg eller på stolpe.',
            amount: "",
            image: "menu.svg",
            price: "395:-/st"
        },
        {
            product_name: 'Menyskåp',
            description: 'För montage på vägg. Plats för 2 st A3 format. I natureloxerad aluminium med frontglas av polycarbonat.',
            amount: "",
            image: "menu_skap.svg",
            price: "1 950:-/st"
        }
    ],
    tillaggform: {
        stativ: [
            {
                checked:false,
                name: 'Grön',
                image: 'stolpe_groen.png'
            },
            {
                checked:false,
                name: 'Natureloxerad',
                image: 'stolpe_silver.png'
            },
            {
                checked:false,
                name: 'Svart',
                image: 'stolpe_svart.png'
            },
            {
                checked:false,
                name: 'Brun',
                image: 'stolpe_brun.png'
            },
            {
                checked:false,
                name: 'Grå',
                image: 'stolpe_graa.png'
            }
        ],
        stativavslut: [
            {
                checked: false,
                name: 'Svart plastlock',
                image: 'stativavslut_lock.jpg'
            },
            {
                checked: false,
                name: 'Klot guld',
                image: 'stativavslut_guld.jpg'
            },
            {
                checked: false,
                name: 'Klot silver',
                image: 'stativavslut_silver.jpg'
            }
        ],
        banderoll: [
            {
                checked: false,
                name: 'Markisväv, kulör',
                disable: false
            },
            {
                checked:false,
                name: 'Vill ha tryck på markisväven',
                disable: true
            }
        ],
        articles : "",
        glas: [
            {
                checked: false,
                name: '8 mm härdat glas'
            }
        ]
    }
};


export default function Tillagg(state = initialState, action) {
    switch(action.type)
    {

        case UPDATE_ARTICLE:
            console.log(action);
            let object = Object.assign({}, state, {
                'tillaggform': Object.assign({}, state.tillaggform, {
                    'articles': action.value
                })
            })
            localStorage.setItem('tillaggform-welandutemiljo', JSON.stringify(object.tillaggform))
            return object;
        case UPDATE_CHECKED:
            
            switch(action.tillaggtype){
                case 'stativ':
                    let update_checked_stativ = state.tillaggform.stativ.map((value, index) => {
                        if(action.index === index)
                        {
                            return {
                                ...value,
                                ... {
                                        checked:action.value
                                    }
                            }
                        }else {
                            return {
                                ...value,
                                ... {
                                    checked:false
                                }
                            }
                        }
                        return value;
                    })
                // localStorage.setItem('tillaggform-welandutemiljo', JSON.stringify(update_checked_stativ))
                let add_stativ = Object.assign({}, state, {
                    'tillaggform': Object.assign({}, state.tillaggform, {
                        'stativ': [...update_checked_stativ]
                    })
                })
                localStorage.setItem('tillaggform-welandutemiljo', JSON.stringify(add_stativ.tillaggform))
                return add_stativ;
                break;
                case 'stativavslut':
                    let update_checked_stativavslut = state.tillaggform.stativavslut.map((value, index) => {
                        if(action.index === index)
                        {
                            return {
                                ...value,
                                ... {
                                        checked:action.value
                                    }
                            }
                        }else {
                            return {
                                ...value,
                                ... {
                                    checked:false
                                }
                            }
                        }
                        return value;
                    })
                // localStorage.setItem('tillaggform-welandutemiljo', JSON.stringify(update_checked_stativavslut))
                let add_stativavslut = Object.assign({}, state, {
                    'tillaggform': Object.assign({}, state.tillaggform, {
                        'stativavslut': [...update_checked_stativavslut]
                    })
                })

                localStorage.setItem('tillaggform-welandutemiljo', JSON.stringify(add_stativavslut.tillaggform))

                return add_stativavslut;
                break;
                case 'banderoll':
                    let update_checked_banderoll = state.tillaggform.banderoll.map((value, index) => {
                        if(action.index === index)
                        {
                            return {
                                ...value,
                                ... {
                                        checked:action.value
                                    }
                            }
                        }else {
                            return {
                                ...value,
                                ... {
                                    checked:false
                                }
                            }
                        }
                        return value;
                    })
                // localStorage.setItem('tillaggform-welandutemiljo', JSON.stringify(update_checked_banderoll))
                let add_banderoll =  Object.assign({}, state, {
                    'tillaggform': Object.assign({}, state.tillaggform, {
                        'banderoll': [...update_checked_banderoll]
                    })
                })
                localStorage.setItem('tillaggform-welandutemiljo', JSON.stringify(add_banderoll.tillaggform))
                return add_banderoll;
                break;
                case 'glas':
                    let update_checked_glas = state.tillaggform.glas.map((value, index) => {
                        if(action.index === index)
                        {
                            if(index == 0)
                            {
                                if(action.value)
                                {
                                    state.tillaggform.banderoll[0].checked = false
                                    state.tillaggform.banderoll[1].checked = false
                                }
                            }
                            return {
                                ...value,
                                ... {
                                        checked:action.value
                                    }
                            }
                        }else {
                            return {
                                ...value,
                                ... {
                                    checked:false
                                }
                            }
                        }
                        return value;
                    })
                
                // localStorage.setItem('tillaggform-welandutemiljo', JSON.stringify(update_checked_glas))                
                let add_glas = Object.assign({}, state, {
                    'tillaggform': Object.assign({}, state.tillaggform, {
                        'glas': [...update_checked_glas]
                    })
                })

                localStorage.setItem('tillaggform-welandutemiljo', JSON.stringify(add_glas.tillaggform))  
                return add_glas;
                break;
                default:
                break;
            }
        case UPDATE_CHECKED_BANDEROLL:
        let update_checked_banderoll = state.tillaggform.banderoll.map((value, index) => {
            if(action.index === index)
            {
                if(index == 1)
                {
                    if(state.tillaggform.banderoll[0].checked)
                    {
                        return {
                            ...value,
                            ... {
                                    checked:action.value
                                }
                        }
                    }
                }
                if(index == 0)
                {
                    if(action.value)
                    {
                        state.tillaggform.glas[0].checked = false;
                        
                    }else {
                        state.tillaggform.banderoll[1].checked = false;
                    }
                    
                    return {
                        ...value,
                        ... {
                                checked:action.value
                            }
                    }
                }
                
            }
            return value;
        })
        let add_banderoll =  Object.assign({}, state, {
            'tillaggform': Object.assign({}, state.tillaggform, {
                'banderoll': [...update_checked_banderoll]
            })
        })
        localStorage.setItem('tillaggform-welandutemiljo', JSON.stringify(add_banderoll.tillaggform))
        return add_banderoll;
        case GET_LOCAL_TILLAGG:
            return Object.assign({}, state, {
                'tillagg': action.data
            })
        case GET_LOCAL_TILLAGGFORM:
            return Object.assign({}, state, {
                'tillaggform': action.data
            }) 
        case UPDATE_AMOUNT_TILLAGG:
            const update_amount = state.tillagg.map((value, i) => {
                if(action.index === i)
                {

                    return {
                        ...value,
                        ...action.data
                    }
                }
                return value;
            })
            localStorage.setItem('tillagg-welandutemiljo', JSON.stringify(update_amount))
            return Object.assign({}, state, {
                'tillagg': [...update_amount]
            })
        default:
        return state
    }

}


// WEBPACK FOOTER //
// ./src/Services/Tillagg/reducer.js